/**
 * Secure Onboarding Configuration Loader
 * 
 * This module loads onboarding configuration files securely from the backend API
 * instead of bundling them with the build or exposing them in public directory.
 * This allows config changes without rebuilding while maintaining security.
 * 
 * Config files are stored securely on the backend in: /src/config/onboarding/
 * - onboarding.development.json (for development environment)
 * - onboarding.production.json (for production environment)
 * 
 * Usage:
 * import { loadOnboardingConfig } from './onboardingConfig';
 * const config = await loadOnboardingConfig();
 */

// Secure config loading from backend API
let onboardingProfile: any = null;

export const loadOnboardingConfig = async (): Promise<any> => {
  if (onboardingProfile) {
    return onboardingProfile;
  }

  try {
    // Use the secure backend API endpoint
    const response = await fetch('/api/Onboarding/config', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // Include any auth headers if needed
        // 'Authorization': `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.statusText}`);
    }
    
    const result = await response.json();
    onboardingProfile = result.data;
    return onboardingProfile;
  } catch (error) {
    console.error('Error loading onboarding config:', error);
    // Return a default/fallback config if needed
    return {};
  }
};

// For backward compatibility, export a default that will be populated after first load
export default onboardingProfile;
